/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";

export const getAIMessages = (query) => {
  var { 
    conversationId,
    messageIds,
    messageId,
    keyword,
    sortBy
  } = query;

  var queryStr = sortBy? `sort=${sortBy}`: `sort=createdAt`;

  if (conversationId)
    queryStr += `&conversation_id=${conversationId}`;

  if (messageIds)
    queryStr += `&message_ids=${messageIds}`;

  if (messageId)
    queryStr += `&message_id=${messageId}`;

  if (keyword)
    queryStr += `&keyword=${keyword}`;

  return API.get(`${process.env.REACT_APP_API_URL}/api/ai-message/get?${queryStr}`);
}

export const updateAIMessages = (aiMessages) => {
  console.log("aiMessageService - updateAllAIMessages", aiMessages);

  return API.post(`${process.env.REACT_APP_API_URL}/api/ai-message/`, aiMessages);
}

export const aiMessageService = {
  getAIMessages,
  updateAIMessages
}
